import React, { Fragment, useState } from "react";
import ArticleLoginForm from './ArticleLoginForm';
import JoinUsingEmail from './JoinUsingEmail';

const ArticleLoginAndJoin = (props) => {
    const [isLoginTag, setLoginTag] = useState(true);

    return (
        <div className="text-left mb-5">
            <Fragment>
            {isLoginTag ? (
                <div>
                    <p className="font-weight-bold" onClick={() => setLoginTag(false)}>Already a VIP Member</p>
                    <p className="text-blue" style={{textDecoration:'none',cursor: 'pointer'}} onClick={() => setLoginTag(false)}>Login Here</p>
                    <JoinUsingEmail props={props} />
                </div>
            ) : (
                <ArticleLoginForm props={props} />
            )}
            
            </Fragment>
            
        <style jsx global>{`
        `}</style>

        </div>
    );
};

export default ArticleLoginAndJoin;